import '@lego/connect-core-tokens';
import '@lego/connect-components-styles';
import '@lego/connect-theme-enterprise';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './../tailwind.css';
import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
